export const enum eventAlbumConstants {
  generateRequest = "EVENT_ALBUM_GENERATE_REQUEST",
  generateSuccess = "EVENT_ALBUM_GENERATE_SUCCESS",
  generateFailure = "EVENT_ALBUM_GENERATE_FAILURE",

  fetchRequest = "EVENT_ALBUM_FETCH_REQUEST",
  fetchSuccess = "EVENT_ALBUM_FETCH_SUCCESS",
  fetchFailure = "EVENT_ALBUM_FETCH_FAILURE",

  fetchBySelectionRequest = "EVENT_ALBUM_FETCH_BY_SELECTION_REQUEST",
  fetchBySelectionSuccess = "EVENT_ALBUM_FETCH_BY_SELECTION_SUCCESS",
  fetchBySelectionFailure = "EVENT_ALBUM_FETCH_BY_SELECTION_FAILURE",

  updatePagesRequest = "EVENT_ALBUM_UPDATE_PAGES_REQUEST",
  updatePagesSuccess = "EVENT_ALBUM_UPDATE_PAGES_SUCCESS",
  updatePagesFailure = "EVENT_ALBUM_UPDATE_PAGES_FAILURE",

  sendReviewRequest = "EVENT_ALBUM_SEND_REVIEW_REQUEST",
  sendReviewSuccess = "EVENT_ALBUM_SEND_REVIEW_SUCCESS",
  sendReviewFailure = "EVENT_ALBUM_SEND_REVIEW_FAILURE",

  customerTokenViewRequest = "EVENT_ALBUM_CUSTOMER_TOKEN_VIEW_REQUEST",
  customerTokenViewSuccess = "EVENT_ALBUM_CUSTOMER_TOKEN_VIEW_SUCCESS",
  customerTokenViewFailure = "EVENT_ALBUM_CUSTOMER_TOKEN_VIEW_FAILURE",

  customerViewRequest = "EVENT_ALBUM_CUSTOMER_VIEW_REQUEST",
  customerViewSuccess = "EVENT_ALBUM_CUSTOMER_VIEW_SUCCESS",
  customerViewFailure = "EVENT_ALBUM_CUSTOMER_VIEW_FAILURE",

  customerApproveRequest = "EVENT_ALBUM_CUSTOMER_APPROVE_REQUEST",
  customerApproveSuccess = "EVENT_ALBUM_CUSTOMER_APPROVE_SUCCESS",
  customerApproveFailure = "EVENT_ALBUM_CUSTOMER_APPROVE_FAILURE",

  reset = "EVENT_ALBUM_RESET",
}
